export default __webpack_public_path__ + "static/slide1-2835fbc473d2b427f48c33a458569e5e.jpg";